module.exports = __webpack_public_path__ + "img/Anatomic-simple-copings.7ab858de.jpg";